const RecaptchaDisclaimer = props => (
  <p {...props}>
    This site is protected by reCAPTCHA and the Google{" "}
    <a
      href="https://policies.google.com/privacy"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      Privacy Policy
    </a>{" "}
    and{" "}
    <a
      href="https://policies.google.com/terms"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      Terms of Service
    </a>{" "}
    apply.
  </p>
);

export default RecaptchaDisclaimer;
